import Vue from "vue";
import axios, { AxiosInstance } from "axios";

// @NOTICE Authorization header will be set in @core/auth/jwt/jwtService via @/auth/jwt/useJwt. Should not be in @core...
const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_GATEWAY,
});

Vue.prototype.$http = axiosInstance;

export default axiosInstance;
